import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostsService } from 'src/app/shared/services/wordpress-api/posts.service';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-blog-details-component',
  templateUrl: './blog-details-component.component.html',
  styleUrls: ['./blog-details-component.component.scss'],
})
export class BlogDetailsComponentComponent implements OnInit {
  slug: string;
  post: any;

  constructor(
    private postsService: PostsService,
    private route: ActivatedRoute,
    private seoService: SeoService,
    private _location: Location
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.slug = params.get('slug');
      this.getPost();
    });
  }

  getPost() {
    let queryParamsString = '?';
    if (this.slug) {
      queryParamsString += 'slug=' + this.slug;
    }

    this.postsService.getPosts(queryParamsString).then(
      (data: any) => {
        this.post = data[0];
        this.getUserDetail(this.post.author);
        this.getMedia(this.post.featured_media);
        this.seoService.updateMeta(this.post.yoast_head);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  data: any;
  getUserDetail(authorId) {
    if (authorId) {
      this.postsService.getUserDetail(authorId).then(
        (data: any) => {
          this.post.author = data;
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
  }
  getMedia(featuredMediaId) {
    if (featuredMediaId) {
      this.postsService.getMedia(featuredMediaId).then(
        (data: any) => {
          this.post.featured_media = data;
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
  }

  goBack(event: MouseEvent) {
    event.preventDefault();  // Prevent the default anchor behavior
    this._location.back();
  }
}
